//
//
//
//
//
//

export default {
	name: 'homePageLayouts',
};
